import { MODE } from "baseui/button-group";
import { gql } from "graphql-request";

export const GET_MODELRUNS_BY_MODELER_QUERY = gql`
  query listModelRuns($filter: FirstLevelFilterInput!, $size: Int, $nextToken: String,  $context: RequestContextInput!) {
    listModelRuns(filter: $filter, size:$size, nextToken: $nextToken, context: $context) {
      items {
        id
        runName
        runStatus
        runNotes
        generated
        createdAt
        createdBy
      }
      nextToken
      
    }
  }
`;
export const CREATE_NEW_MODELRUN_MUTATION = gql`
  mutation createNewModelRun($input: CreateModelRunInput!, $context: RequestContextInput!) {
    createModelRun(input: $input, context: $context) {
      id
      inputValues {
        itemName
        itemValue
      }
      runName
      runStatus
      generated
      runNotes
    }
  }
`;
export const UPDATE_MODEL_RUN = gql`
  mutation updateModelRun($modelRun: UpdateModelRunInput!, $condition: SecondLevelIDInput! ,$context: RequestContextInput!) {
    updateModelRun(input: $modelRun, condition: $condition , context: $context) {
      inputValues {
        itemName
        itemValue
      }
      modelerId
      id
      runName
      runStatus
      generated
      runNotes
    }
  }
`;
export const DELETE_MODELRUN_MUTATION = gql`
  mutation deleteModelRun($id: SecondLevelIDInput!, $context: RequestContextInput!) {
    deleteModelRun(input: $id, context: $context) {
      id
    }
  }
`;
const ASSET_FIELDS_FRAGMENT = gql`
  fragment AssetFields on AssetItem {
    id
    filename
    type
    name
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
`;

const TASK_FIELDS_FRAGMENT = gql`
  fragment ModelRunTaskFields on ModelRunTask {
    id
    lastStatus
    desiredStatus
    logs
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
`;

export const GET_MODELRUN_BY_ID_QUERY = gql`
  query getModelRunById($id: SecondLevelIDInput!, $context: RequestContextInput!) {
    getModelRun(id: $id, context: $context) {
      id
      inputValues {
        itemName
        itemValue
      }
      postProcess
      runName
      runStatus
      generated
      runNotes
      assets {
        items {
          ...AssetFields          
        }
      }
    }
  }
  ${ASSET_FIELDS_FRAGMENT}
`;


export const CREATE_ASSET_ITEM_MUTATION = gql`
  mutation createAssetItem($asset: CreateAssetItemInput!, $context: RequestContextInput!) {
    createAssetItem(input: $asset, context: $context) {
      ...AssetFields
    }
  }
  ${ASSET_FIELDS_FRAGMENT}
`;

export const GENERATE_RUN_MUTATION = gql`
  mutation generateRun(
    $input: GenerateRunInput!
    $context: RequestContextInput!
  ) {
    generateRun(input: $input, context: $context) {
      id
      runStatus
      generated
    }
  }
`;

export const UPDATE_ASSET_ITEM_MUTATION = gql`
  mutation updateAssetItem($asset: UpdateAssetItemInput!, $context: RequestContextInput!) {
    updateAssetItem(input: $asset, context: $context) {
      ...AssetFields
    }
  }
  ${ASSET_FIELDS_FRAGMENT}
`;

export const DELETE_MODELRUN_ASSET_MUTATION = gql`
  mutation deleteModelRunAssetItem($input: ThirdLevelIDInput!, $context: RequestContextInput!) {
    deleteAssetItem(input: $input, context: $context) {
      id
    }
  }
`;

export const EXECUTE_MODELRUN_MUTATION = gql`
  mutation executeModelRunTask($input: ExecuteModelRunTaskInput!, $context: RequestContextInput!) {
    executeModelRunTask(input: $input, context: $context) {
      ...ModelRunTaskFields
    }
  }
  ${TASK_FIELDS_FRAGMENT}
`;

export const TERMINATE_MODELRUN_TASK_MUTATION = gql`
  mutation terminateModelRunTask($input: TerminateModelRunTaskInput!, $context: RequestContextInput!) {
    terminateModelRunTask(input: $input, context: $context) {
      ...ModelRunTaskFields
    }
  }
  ${TASK_FIELDS_FRAGMENT}
`;

export const EXECUTE_POST_PROCESSING_MUTATION = gql`
  mutation executePostProcess($input: ExecutePostProcessInput!, $context: RequestContextInput!) {
    executePostProcess(input: $input, context: $context) {
      operationId
      result
      status
      logs
    }
  }
`;

export const GET_OPERATION_OVERVIEW_QUERY = gql`
  query getOperationOverview($input: OperationOverviewInput!, $context: RequestContextInput!) {
    getOperationOverview(input: $input, context: $context) {
      operationId
      status
      logs
      result
    }
  }
`;

export const GET_MODELRUN_TASKS_QUERY = gql`
  query listModelRunTasks($filter: SecondLevelFilterInput!,$size: Int, $nextToken: String, $context: RequestContextInput!) {
    listModelRunTasks(filter: $filter, size: $size, nextToken: $nextToken, context: $context) {
      items {
        ...ModelRunTaskFields
      }
      nextToken
    }
  }
  ${TASK_FIELDS_FRAGMENT}
`;

export const GET_MODELRUN_ASSETS_QUERY = gql`
  query listAssetItems($filter: SecondLevelFilterInput!, $size: Int, $nextToken: String, $context: RequestContextInput!) {
    listAssetItems(filter: $filter, size: $size, nextToken: $nextToken, context: $context) {
      items {
        ...AssetFields
      }
      nextToken
    }
  }
  ${ASSET_FIELDS_FRAGMENT}
`;
